export const CloudCoverageTypes = [
	{ value: "", text: "" },
	{ value: "Clear", text: "Clear" },
	{ value: "Scattered", text: "Scattered" },
	{ value: "Broken", text: "Broken" },
	{ value: "Overcast", text: "Overcast" },
];
